export function cssVars (propNames) {
  const $el = this || document.documentElement;
  if (Array.isArray(propNames))
    return propNames.map(propName =>
      getComputedStyle($el).getPropertyValue(propName),
    );
  else if (typeof propNames === 'object') {
    Object.keys(propNames).forEach(propName =>
      $el.style.setProperty(propName, propNames[propName]),
    );
  }
  return getComputedStyle($el).getPropertyValue(propNames);
}

export const px = (n) => `${ n }px`;
px.value = (n) => Number(n.trim().match(/^[\d.]+/)[0]);
